import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import NumberPad from './NumberPad';

export default function NumberPadModal({ open, initialValue, onConfirm, onCancel }) {
  console.log('NumberPadModal', open);

  function handleCancel() {
    console.log('handleCancel');
    onCancel();
  }

  function handleConfirm(v) {
    console.log('handleConfirm', v);
    onConfirm(v);
  }

  function handleOnClose() {
    console.log('handleOnClose');
    onCancel();
  }

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as='div'
        className='fixed inset-0 z-10 overflow-y-auto'
        onClose={handleOnClose}
      >
        <div className='min-h-screen px-4 text-center'>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay className='fixed inset-0' />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className='inline-block h-screen align-middle'
            aria-hidden='true'
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0 scale-95'
            enterTo='opacity-100 scale-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100 scale-100'
            leaveTo='opacity-0 scale-95'
          >
            <div className='inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-indigo-300 shadow-xl rounded-2xl'>
                <NumberPad 
                    onCancel={()=>handleCancel()} 
                    onConfirm={(v)=>handleConfirm(v)} 
                />
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
